import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllUndeliveredCustomerOrderPackagesView } from "src/components/views/erp/sales/delivery/AllUndeliveredCustomerOrderPackagesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/picking/undeliveredPackages")({
	staticData: { title: i18n.t("undelivered_packages"), legacyViewKey: "undeliveredCustomerOrderPackagesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllUndeliveredCustomerOrderPackagesView />;
}
